module.exports = __webpack_public_path__ + "static/media/warning-delete-file.a2cae93d.svg";